import React, { useState } from "react";

const ThirdBox = (props) => {
  // Convert to string to ensure compatibility with BorderedNumberInput
  const [borderedNumberInputValue, setBorderedNumberInputValue] = useState(
    props?.stock?.commercial_quantity !== undefined ? String(props?.stock?.commercial_quantity) : "0"
  );

  const handleSave = () => {
    const externalString = props?.stock?.commercial_quantity !== undefined ? String(props?.stock?.commercial_quantity) : "";
    if (borderedNumberInputValue !== externalString) {
      if (props?.setStock) {
        const numeric = Number(borderedNumberInputValue);
        const finalValue = Number.isNaN(numeric) ? 0 : numeric;
        props.setStock({
          ...props.stock,
          commercial_quantity: finalValue,
          stock_behavior: 0,
          deliverability: 0,
        });
      }
      if (props?.setUpdatedStock) {
        props.setUpdatedStock(true);
      }
    }
  };

  return (
    <>
      <div
        className="whiteBox p-5 h-100"
      >
        <h4 className="fw-bold">Voorraad</h4>
        <div className="d-flex flex-row">
          <div className="d-flex flex-column">
            <div className="d-flex flex-column">
              <label className="">Voorraad hoeveelheid</label>

              <div className="d-flex align-items-center">
                <div className="TextInputWrapper w-75">
                  <div className="input-container" style={{ position: 'relative', width: '100%' }}>
                    <input
                      type="text"
                      inputMode="numeric"
                      placeholder={borderedNumberInputValue}
                      onChange={(e) => {
                        const filtered = e.target.value.replace(/[^0-9.-]/g, "");
                        setBorderedNumberInputValue(String(filtered));
                      }}
                      onWheel={(e) => e.currentTarget.blur()}
                      onBlur={() => {handleSave();}}
                      className="BorderedTextInput"
                      aria-label="Voorraad hoeveelheid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThirdBox;
